import { Card, Group, Image, Text } from "@mantine/core";
import { ButtonLink } from "./button-link";

type NavigationCardProps = {
  title: string;
  description: string;
  to: string;
  splash: string;
};

export function NavigationCard({
  title,
  description,
  splash,
  to,
}: NavigationCardProps) {
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder maw="350px">
      <Card.Section>
        <Image src={splash} height={160} alt="" />
      </Card.Section>
      <Group justify="space-between" mt="md" mb="xs">
        <Text fw={500}>{title}</Text>
      </Group>
      <Text size="sm" c="dimmed">
        {description}
      </Text>
      <ButtonLink
        variant="light"
        color="blue"
        fullWidth
        mt="md"
        radius="md"
        to={to}
      >
        {title}
      </ButtonLink>
    </Card>
  );
}
